import { ChangeDetector, IndicesController, ListItem } from '@dcupl/common';

import { DcuplModel } from '../model-parser';

import { CatalogApi } from './catalog-api';

import { DcuplApi } from '../dcupl/dcupl-api';

export class Catalog<ListType extends ListItem = ListItem> extends CatalogApi<ListType> {
  protected listKey!: string;
  constructor(
    protected dcuplApi: DcuplApi,
    protected cdRef: ChangeDetector,
    protected indicesController: IndicesController,
  ) {
    super(dcuplApi, cdRef, indicesController);
  }

  protected init(listKey: string, model: DcuplModel<ListType>, data: Map<string, ListType>): void {
    this.listKey = listKey;
    this.model = model;
    this.filter.init(model, data);
    super.initListeners();
  }

  protected update(
    model: DcuplModel<ListType>,
    data: Map<string, ListType>,
    indicesController: IndicesController,
  ): void {
    this.model = model;
    this.filter.update(model, data, indicesController);
  }
}
